<template>
	<div class="page" v-loading="loadingPage">
		<div class="page-title bg-white padding-lr flex justify-between align-center shadow-warp border-bottom">
			<div class="text-lg text-bold">
				<i class="el-icon-caret-right"></i>
				{{ $route.meta.title }}
			</div>
			<router-link to="/contract/archive/list">
				<el-button type="warning" round size="small">
					<span class="el-icon-refresh-left"></span>
					返回列表
				</el-button>
			</router-link>
		</div>
		<div class="page-main">
			<div class="padding-tb-xl padding-lr bg-white">
				<el-form ref="formAdd" :model="formAdd" label-width="150px" label-suffix=":">
					<el-form-item label="合同编号" prop="number" :rules="{ required: true, message: '请输入合同编号', trigger: 'blur' }">
						<el-input v-model="formAdd.number" placeholder="合同编号" autocomplete="off" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item label="合同分类" prop="class" :rules="{ required: true, message: '请选择合同分类', trigger: 'blur' }">
						<el-cascader
							:options="classListData"
							:show-all-levels="true"
							:props="{ value: 'id', label: 'name', emitPath: false }"
							v-model="formAdd.class"
							clearable
							placeholder="合同分类"
							@visible-change="getClassListData"
						></el-cascader>
					</el-form-item>
					<el-form-item label="关联客户" prop="customer" :rules="{ required: true, message: '请选择客户信息', trigger: 'blur' }">
						<el-button size="small" type="" plain class="radius text-gray" @click="dialogVisibleCheckCustomer = true">
							<div class="flex align-center">
								<div class="text-left" style="line-height: 22px;" v-if="customer">
									<div class="flex align-center">
										<span class="text-bold text-black text-df">{{ customer.name }}</span>
										<el-tag size="mini" class="margin-left-sm">公司</el-tag>
									</div>
									<div class="text-grey">{{ customer.credit_code }}</div>
								</div>
								<div class="text-center" v-else><span>点击选择客户</span></div>
								<div class="margin-left"><span class="iconfont-genghuan" style="font-size: 32px;"></span></div>
							</div>
						</el-button>
						<check-customer :show="dialogVisibleCheckCustomer" :current="customer" @close="dialogVisibleCheckCustomer = false" @check="checkCustomer"></check-customer>
					</el-form-item>
					<el-form-item label="联系人" prop="contacter" :rules="{ required: true, message: '请填写联系人', trigger: 'blur' }">
						<el-button size="small" type="" plain class="radius text-gray" @click="dialogVisibleCheckContacter = true" v-if="Object.keys(formAdd.customer).length > 0">
							<div class="flex align-center">
								<div class="text-left" style="line-height: 22px;" v-if="contacter">
									<div class="flex align-center">
										<span class="text-bold text-black text-df">{{ contacter.name }}</span>
										<el-tag size="mini" class="margin-left-sm">先生</el-tag>
									</div>
									<div class="text-grey">{{ contacter.mobile }}</div>
								</div>
								<div class="text-center" v-else><span>点击选择</span></div>
								<div class="margin-left"><span class="iconfont-genghuan" style="font-size: 32px;"></span></div>
							</div>
						</el-button>
						<div v-else class="text-orange">
							<span class="iconfont-tishi"></span>
							<span class="">请先选择客户</span>
						</div>
						<check-contacter
							:show="dialogVisibleCheckContacter"
							:customer="customer"
							:current="contacter"
							@close="dialogVisibleCheckContacter = false"
							@check="checkContacter"
						></check-contacter>
					</el-form-item>
					<el-form-item label="签约时间" prop="sign_time" :rules="{ required: true, message: '请选择签约时间', trigger: 'blur' }">
						<el-date-picker v-model="formAdd.sign_time" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
					</el-form-item>
					<el-form-item label="签约人" prop="sign_user_id" :rules="{ required: true, message: '请选择合同签约人', trigger: 'blur' }">
						<el-button size="medium" @click="showCheckEmployee('signer')">
							<span v-if="signer">{{ signer.name }}({{ signer.officeid }})</span>
							<span v-else>点击选择</span>
							<i class="el-icon-arrow-down margin-left-sm"></i>
						</el-button>
					</el-form-item>
					<el-form-item label="合同照片" prop="picture" :rules="{ required: true, message: '请上传合同照片', trigger: 'blur' }">
						<el-upload
							class="avatar-uploader"
							:action="$cfg.upload + '?a=upload'"
							list-type="picture-card"
							:auto-upload="true"
							:on-preview="upload_preview"
							:on-remove="upload_remove"
							:on-change="upload_change"
							:on-success="upload_success"
							:before-remove="upload_remove_before"
							:class="{ hide: hideUpload }"
							:multiple="true"
							:limit="9"
							:on-exceed="upload_exceed"
							accept="image/png, image/jpeg"
							:file-list="pictureList"
						>
							<i slot="default" class="el-icon-plus"></i>
							<div slot="tip" class="el-upload__tip">
								<span class="el-icon-info"></span>
								只能上传jpg/png文件，单个图片不超过5MB，最多只能上传9张
							</div>
						</el-upload>
					</el-form-item>
					<el-form-item label="合同描述" prop="description">
						<el-input v-model="formAdd.description" type="textarea" rows="5" placeholder="如有特殊情况,请做说明" autocomplete="off" style="width: 600px;"></el-input>
					</el-form-item>
					<el-form-item label="备注">
						<el-input type="textarea" placeholder="请输入内容" v-model="formAdd.remark" maxlength="140" show-word-limit rows="5" :style="{ width: '600px' }"></el-input>
					</el-form-item>
					<el-divider content-position="left"></el-divider>
					<el-form-item>
						<el-button type="primary" @click="formSubmitAdd('formAdd')">保存提交</el-button>
						<el-button @click="dialogAdd = false">取 消</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-image-viewer v-if="showViewer" :on-close="preview_close" :url-list="previewImgList" />
		<check-employee :show="checkEmployeeShow" :dKey="checkEmployeeKey" @close="checkEmployeeClose" @change="changeEmployee"></check-employee>
	</div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import checkCustomer from '@/components/check-customer.vue';
import checkContacter from '@/components/check-contacter.vue';
import checkEmployee from '@/components/check-employee.vue';

export default {
	components: { ElImageViewer, checkCustomer, checkContacter, checkEmployee },
	data() {
		return {
			loadingPage: false,
			loadingClass: false,
			classListData: [],
			noDataTextClass: '无数据',
			checkEmployeeShow: false,
			checkEmployeeKey: null,
			signer: null,
			customer: null,
			contacter: null,
			noMatchText: '',
			formAdd: {
				customer: {},
				contacter: {},
				picture: []
			},
			hideUpload: false,
			pictureList: [],
			previewImgList: [],
			showViewer: false,
			dialogVisibleCheckCustomer: false,
			dialogVisibleCheckContacter: false
		};
	},
	beforecreate: function() {},
	created: function() {},
	mounted: function() {},
	updated: function() {},
	methods: {
		getClassListData(open) {
			if (this.classListData.length < 1 && open) {
				this.$http.post('/server/index.php?m=contract/archive&a=getClassList', {}).then(
					res => {
						if (res.result == 'ok') {
							this.classListData = res.data;
						} else {
							this.$message.error({ message: '获取分类列表信息失败：' + res.msg, offset: 250 });
						}
					},
					r => {
						this.$message.error({ message: '获取分类列表信息失败', offset: 250 });
					}
				);
			}
		},
		showCheckEmployee(key) {
			this.checkEmployeeShow = true;
			this.checkEmployeeKey = key;
		},
		checkEmployeeClose() {
			this.checkEmployeeShow = false;
		},
		changeEmployee(e) {
			this[e.key] = e.data;
		},
		checkCustomer(customer) {
			this.formAdd.customer = customer.id;
			this.customer = customer;
			if (customer.contacter) {
				this.checkContacter(customer.contacter);
			} else {
				this.formAdd.contacter = '';
				this.contacter = null;
			}
		},
		checkContacter(contacter) {
			this.formAdd.contacter = contacter.id;
			this.contacter = contacter;
		},
		upload_upload(p) {},
		upload_before(file) {
			if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
				this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
				return false;
			}
			if (file.size / 1024 / 1024 > 5) {
				this.$message.error('上传图片大小不能超过 5MB!');
				return false;
			}
		},
		upload_exceed(file, fileList) {
			this.$message.error('上传的图片超过最多限制');
		},
		upload_change(file, fileList) {},
		upload_remove_before(file, fileList) {
			return this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.$message({
						message: '删除成功',
						type: 'success'
					});
				})
				.catch(() => {
					reject(false);
				});
		},
		upload_remove(file, fileList) {
			this.pictureList = fileList;
			this.hideUpload = fileList.length >= 9;
		},
		upload_success(response, file, fileList) {
			file.url = response.data.url;
			this.pictureList = fileList;
			this.hideUpload = fileList.length >= 9;
		},
		upload_preview(file) {
			let index = this.pictureList.indexOf(file);
			let tempImgList = [];
			for (let i = 0; i < this.pictureList.length; i++) {
				tempImgList.push(this.pictureList[i].url);
			}
			let temp = [];
			for (let i = 0; i < index; i++) {
				temp.push(tempImgList.shift());
			}
			this.previewImgList = tempImgList.concat(temp);
			this.showViewer = true;
		},
		preview_close() {
			this.showViewer = false;
		},
		formSubmitAdd: function(formName) {
			let picture = [];
			for (let i = 0; i < this.pictureList.length; i++) {
				picture.push({ name: this.pictureList[i].name, url: this.pictureList[i].url });
			}
			this.formAdd.picture = picture;
			this.$refs[formName].validate(valid => {
				if (valid) {
					const loading = this.$loading({
						lock: true,
						text: '处理中...',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$http.post('/server/index.php?m=contract/archive&a=add', { data: this.formAdd }).then(
						res => {
							loading.close();
							if (typeof res.data != 'object') {
								this.$alert(res.data ? res.data : '(无返回数据)', {
									title: '返回数据格式错误',
									type: 'error'
								});
							} else {
								if (res.data.result == 'ok') {
									this.$alert('录入合同成功！', {
										title: '操作成功',
										type: 'success',
										callback: () => {
											this.$router.back(-1);
										}
									});
								} else {
									this.$alert(res.data.msg, {
										title: '操作错误',
										type: 'error'
									});
								}
							}
						},
						r => {
							loading.close();
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
					return false;
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		}
	}
};
</script>

<style></style>
